/**
 * Informational modal for service contracts - used in PDP(Product Page)
 * Shows only information without action buttons inside Modal
 */

'use client';

import { ServiceContractModalBase } from './ServiceContractModalBase';

type AcceptanceTerm = {
  title: string;
  message: string;
};

export type ServiceContractInfoProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  acceptanceTerms?: AcceptanceTerm[];
};

function ServiceContractInfoModal(props: Readonly<ServiceContractInfoProps>) {
  const { isOpen, onOpenChange, title, acceptanceTerms } = props;

  return (
    <ServiceContractModalBase
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={title}
      acceptanceTerms={acceptanceTerms}
    />
  );
}

export default ServiceContractInfoModal;
